<template>
  <b-form class="row">

    <b-col xl="4">
      <b-form-group>
        <label for="">Empresa</label>
        <el-select id="empresa" name="empresa" v-model="filtro.empresa"
                   filterable remote clearable no-data-text="No hay datos que coincidan"
                   no-match-text="No hay datos que coincidan" :remote-method="obtenerEmpresasFiltro">
          <el-option v-for="empresa in empresas_filtro" :key="empresa.id" :label="empresa.nombre" :value="empresa.id">
          </el-option>
        </el-select>
      </b-form-group>
    </b-col>

    <b-col xl="2">
      <b-form-group>
        <label for="nombre">Nombre</label>
        <b-form-input style="padding: 15px" size="sm" id="nombre" name="nombre" type="text" v-model="filtro.nombre"/>
      </b-form-group>
    </b-col>

    <b-col xl="2">
      <b-form-group>
        <label for="">Fabricante</label>
        <el-select id="id_fabricante" name="id_fabricante" v-model="filtro.id_fabricante" filterable remote clearable
                   class="el_select_fab"
                   no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                   :remote-method="obtenerFabricantesFiltro">
          <el-option v-for="fabricante in fabricantes_filtro" :key="fabricante.id" :label="fabricante.nombre"
                     :value="fabricante.id"/>
        </el-select>
      </b-form-group>
    </b-col>


    <b-col xl="2">
      <b-form-group>
        <label for="component">Componentes</label>
        <el-select id="component" name="component" v-model="filtro.component"
                   placeholder="Por nombre o numero de cas"
                   filterable remote clearable no-data-text="No hay datos que coincidan"
                   no-match-text="No hay datos que coincidan" :remote-method="searchComponentRemote">
          <el-option v-for="component in todosLoscomponentes.data" :key="component.id" :label="component.name"
                     :value="component.id">
          </el-option>
        </el-select>
      </b-form-group>
    </b-col>


    <b-col xl="2" lg="6">
      <b-form-group label="Año de importación">
        <el-date-picker
            v-model="filtro.year_import"
            type="year"
            format="yyyy"
            :picker-options="pickerOptions"
        ></el-date-picker>
      </b-form-group>
    </b-col>


    <b-col xl="12" lg="4" class="mt-4">
      <b-form-checkbox v-model="filtro.is_imported" class="pull-left">
        Importados
      </b-form-checkbox>

      <b-form-checkbox v-model="filtro.is_made" class="pull-left ml-3">
        Fabricados
      </b-form-checkbox>

    </b-col>


    <b-col cols="12" class="mt-4">
      <b-button-group size="md">
        <b-button :disabled="!filtro.empresa " variant="primary" @click.prevent="searchProducts()">
          <i class="fa fa-search fa-lg"></i>
          <span class="d-none d-md-inline-block">Buscar</span>
        </b-button>
        <b-button @click.prevent="clearFilter">
          <i class="fa fa-eraser fa-lg"></i>
          <span class="d-none d-md-inline-block"> Limpiar</span>
        </b-button>
      </b-button-group>

      <b-dropdown :disabled="!filtro.empresa" variant="primary" id="dropdown-1" text="Opciones" class="pull-right">
        <b-dropdown-item :disabled="!filtro.year_import"
                         @click.prevent="downloadFormat"
                         variant="outline-primary">
          <i class="fa fa-download mr-1"></i>
          <span>Descargar plantilla</span>
        </b-dropdown-item>
        <b-dropdown-item v-b-modal.modal_upload_file_decret>
          <i class="fa fa-upload mr-1"></i>
          <span>Cargar información</span>
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="showProccessBackground">
          <i class="fa fa-list mr-1"></i>
          <span>Ver procesos agendados</span>
        </b-dropdown-item>
      </b-dropdown>


    </b-col>

  </b-form>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {validarPermisoComponente} from "@/plugins/acl";

export default {
  name: "FormSearch",
  data() {
    return {
      validarPermisoComponente: validarPermisoComponente,
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear() - 1;
        },
      }
    }
  },
  destroyed() {
    this.clearFilter()
  },
  methods: {
    ...mapActions('productos', ['obtenerFabricantesFiltro', 'fetchProviders', 'obtenerEmpresasFiltro', 'cargarTipoProducto']),
    ...mapActions('nuevocas', ['listarComponentes']),
    ...mapActions('decret_1630', ['getPrDcrHistoricalImports', 'exportProductsForImport', 'loadProccessBackground']),
    ...mapMutations('productos', ['resetProductos', 'setFiltro', 'resetFiltro']),
    ...mapMutations('nuevocas', ['setFiltroBuscadorComponente']),
    ...mapMutations('decret_1630', ['setCompanyId']),
    async searchProducts() {
      this.setCompanyId(this.filtro.empresa);
      this.setFiltro(this.filtro);
      this.filtro.is_decret = true;
      await this.getPrDcrHistoricalImports(this.filtro)
    },
    async searchComponentRemote(val) {
      this.setFiltroBuscadorComponente({
        buscar: val,
        page: 1,
      })
      await this.listarComponentes();
    },
    clearFilter() {
      delete this.filtro.is_decret
      this.resetFiltro();
    },
    async downloadFormat() {
      let payload = clone(this.filtro);
      payload.year_import = new Date(this.filtro.year_import).getFullYear();
      await this.exportProductsForImport(payload)
    },
    async showProccessBackground() {
     await this.loadProccessBackground({company_id: this.filtro.empresa, type: 'INVENTARIO-PRODUCTOS-DECRETO-1630'});
      this.$bvModal.show('modal_process_background');
    },
  },
  computed: {
    ...mapState('productos', ['fabricantes_filtro', 'proveedores', 'empresas_filtro', 'tipoProductos', 'filtro']),
    ...mapState('nuevocas', ['todosLoscomponentes']),

  }
}
</script>

<style>

.el-input__inner {
  height: 32px !important;
}

</style>
